import TalentImg1 from "../../images/Rectangle_1325.png"
import TalentImg2 from "../../images/Rectangle_1328.png"
import TalentImg3 from "../../images/Rectangle_1273.png"
import TalentImg4 from "../../images/Rectangle_1275.png"
import TalentImg5 from "../../images/Rectangle_1277.png"
import TalentImg6 from "../../images/Rectangle_1326.png"
import TalentImg7 from "../../images/Rectangle_1327.png"
import ProfilePic from "../../images/Ellipse_170.png"
import Location from "../../images/Icon-material-location-on.png"

class FindProjectAPI {
    static projectPages = {
        "online-typing": {
            name: "Online Typing",
            to: "/find-project/online-typing",
            image: TalentImg1,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "video-editing": {
            name: "Video Editing",
            to: "/find-project/video-editing",
            image: TalentImg2,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "graphics-design": {
            name: "Graphics & Design",
            to: "/find-project/graphics-design",
            image: TalentImg3,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "typing-jobs": {
            name: "Typing Jobs",
            to: "/find-project/typing-jobs",
            image: TalentImg4,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        },
        "content-writing": {
            name: "Content Writing",
            to: "/find-project/content-writing",
            image: TalentImg5,
            types: ["Graphics Design", "Banner Ad Design", "Art And Illustration", "Logo Design", "Broucher Design"]
        }
    };

    static projects = [{
        projectImg: TalentImg1,
        to: '/find-project/typing-jobs/Graphics Design/122',
        title: 'Typing Jobs',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        projectImg: TalentImg2,
        title: 'Graphics Design',
        to: '/find-project/graphics-design/Graphics Design/122',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        projectImg: TalentImg6,
        title: 'Video Editing',
        to: '/find-project/video-editing/Graphics Design/122',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        projectImg: TalentImg7,
        title: 'Content Writing',
        to: '/find-project/content-writing/Graphics Design/122',
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    }];
    static fetchProjectsByType = (type, subType = undefined, page = 1, searchInput = '', filters = {}) => {
        //change this api calling logic with actual API
        const res = this.projects.slice(page % this.projects.length).concat(this.projects.slice(0, page % this.projects.length));
        return [...res, ...res, ...res];
    }

    static fetchProjects = (limit = 8, offset = 0) => {
        //change this api calling logic with actual API
        return [...this.projects, ...this.projects, ...this.projects].splice(offset, limit);
    }
}
export default FindProjectAPI;